var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition",
    {
      attrs: {
        "enter-active-class": "animated fadeIn",
        "leave-to-class": "animated fadeOut"
      }
    },
    [
      _vm.errorsForm.has(_vm.attributeName)
        ? _c("div", { staticClass: "pt-1 pl-2 pr-2 text-xs text-danger" }, [
            _c("span", { staticClass: "error-message" }, [
              _vm._v(_vm._s(_vm.errorsForm.first(_vm.attributeName)))
            ])
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }